var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasets({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5001 14.6468C23.5415 14.6468 16.5261 18.3621 16.5261 23.1036V41.8964C16.5261 46.4011 23.9906 50.3532 32.5001 50.3532C41.0095 50.3532 48.474 46.4011 48.474 41.8964V23.1036C48.474 18.3621 41.4586 14.6468 32.5001 14.6468ZM32.5001 16.5261C40.1394 16.5261 46.5947 19.5386 46.5947 23.1036C46.5947 26.6686 40.1394 29.6811 32.5001 29.6811C24.8608 29.6811 18.4054 26.6686 18.4054 23.1036C18.4054 19.5386 24.8608 16.5261 32.5001 16.5261ZM46.5947 41.8964C46.5947 44.939 40.4382 48.4739 32.5001 48.4739C24.5619 48.4739 18.4054 44.939 18.4054 41.8964V36.5384C21.0721 39.1901 26.3228 40.9568 32.5001 40.9568C38.6773 40.9568 43.928 39.1901 46.5947 36.5384V41.8964ZM46.5947 32.5C46.5947 36.065 40.1394 39.0775 32.5001 39.0775C24.8608 39.0775 18.4054 36.065 18.4054 32.5V27.142C21.0721 29.7937 26.3228 31.5604 32.5001 31.5604C38.6773 31.5604 43.928 29.7937 46.5947 27.142V32.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasets);
export default __webpack_public_path__ + "static/media/datasets.8773b9a13383cb78963f94496abdb91e.svg";
export { ForwardRef as ReactComponent };